// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import 'element-ui/lib/theme-chalk/base.css'
import CollapseTransition from 'element-ui/lib/transitions/collapse-transition';
import 'vue-beauty/package/style/vue-beauty.min.css'
import vueBeauty from 'vue-beauty'
// import {dropdown, pagination, datePicker, form, timePicker, tree, badge, select, button} from 'vue-beauty'
import locale from '../node_modules/element-ui/lib/locale/lang/en'
import App from './App'
import router from './router'
import store from './store/index'
import axios from 'axios'
import VCharts from 'v-charts'
import lodash from 'lodash'
//引入flexible做屏幕适配
// import 'lib-flexible'
import './utils/flexible'
import moment from "moment"
import VueAwesomeSwiper from 'vue-awesome-swiper'
// import style (<= Swiper 5.x)
import 'swiper/dist/css/swiper.css'
import clipboard from 'clipboard';
import {i18n, useI18n} from '@/js/i18n/lang'

Vue.use(VueAwesomeSwiper, /* { default options with global component } */)
// 引用API文件
// import api from '@/api/axios.js'
// import api from '@/api/restfulAPI.js'
// 将API方法绑定到全局
// Vue.prototype.$api = api
Vue.prototype.$axios = axios
Vue.prototype.$moment = moment;
Vue.use(VCharts)
Vue.use(lodash)
Vue.use(ElementUI, {locale})
Vue.component(CollapseTransition.name, CollapseTransition)
Vue.config.productionTip = false
Vue.use(vueBeauty)
useI18n(Vue)
// ----------vueBeauty按需引入---------------
// Vue.use(dropdown)
// Vue.use(pagination)
// Vue.use(datePicker)
// Vue.use(form)
// Vue.use(timePicker)
// Vue.use(tree)
// Vue.use(badge)
// Vue.use(select)
// Vue.use(button)
//--------------------------------
Vue.filter('dateFormat', function(originVal, pattern="") {
  const dt = new Date(originVal)

  const y = dt.getFullYear()
  const m = (dt.getMonth() + 1 + '').padStart(2, '0')
  const d = (dt.getDate() + '').padStart(2, '0')

  const hh = (dt.getHours() + '').padStart(2, '0')
  const mm = (dt.getMinutes() + '').padStart(2, '0')
  const ss = (dt.getSeconds() + '').padStart(2, '0')

  if(pattern.toLocaleLowerCase() === 'yyyy-mm-dd') {
    return `${y}-${m}-${d}`
  } else if(pattern.toLocaleLowerCase() === 'yyyy/mm/dd') {
    return `${y}/${m}/${d}`
  } else {
    return `${y}-${m}-${d} ${hh}:${mm}:${ss}`
  }
})

Vue.prototype.clipboard = clipboard;
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  i18n,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js